var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 1.19995C9.22711 1.19995 7.47609 4.30455 3.97405 10.5137L3.53766 11.2875C0.627494 16.4473 -0.827589 19.0272 0.487509 20.9136C1.80261 22.8 5.05627 22.8 11.5636 22.8H12.4364C18.9437 22.8 22.1974 22.8 23.5125 20.9136C24.8276 19.0272 23.3725 16.4473 20.4623 11.2875L20.0259 10.5137C16.5239 4.30455 14.7729 1.19995 12 1.19995Z",
    fill: "#FFA033"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 6C12.8856 6 13.3333 6.44772 13.3333 7V13.6667C13.3333 14.219 12.8856 14.6667 12.3333 14.6667C11.781 14.6667 11.3333 14.219 11.3333 13.6667V7C11.3333 6.44772 11.781 6 12.3333 6Z",
    fill: "#FFA033"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 19C13.0697 19 13.6667 18.403 13.6667 17.6667C13.6667 16.9303 13.0697 16.3333 12.3333 16.3333C11.597 16.3333 11 16.9303 11 17.6667C11 18.403 11.597 19 12.3333 19Z",
    fill: "#FFA033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalse);
export default __webpack_public_path__ + "static/media/false.05ee5da140eeceba800b0caf961cb627.svg";
export { ForwardRef as ReactComponent };